import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { AxiosError } from "axios";
import React, { FormEvent, useContext, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Logo from "src/components/Logo";
import { AUTH_TOKEN } from "src/const";
import { AuthContext } from "src/contexts/AuthContext";
import { PATHS } from "src/router";
import { httpAuthorizedRequest } from "src/services/httpService";

type AlenOTPError = {
  code: string;
  message: string;
};
export default function AlenOTP() {
  const { user, signin, signout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const handleVerify = async (e: FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await httpAuthorizedRequest.post("/v1/auth/alen_otp", {
        code,
      });
      const { token } = response.data;
      localStorage.setItem(AUTH_TOKEN, token);
      signin(token);
      navigate(PATHS.FLEET_MANAGEMENT, { replace: true });
    } catch (err) {
      if (err instanceof AxiosError) {
        const alenErrors = err.response?.data;
        if (alenErrors) {
          setErrors(
            alenErrors.map((alenError: AlenOTPError) => alenError.message)
          );
        } else {
          setErrors(["Something went wrong"]);
        }
      } else if (err instanceof Error) {
        setErrors([err.message]);
      } else {
        setErrors(["Something went wrong"]);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <Navigate to={PATHS.LOGIN} />;
  }
  return (
    <Container
      maxWidth="xs"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <form onSubmit={handleVerify}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Logo sx={{ marginBottom: "2rem" }} />
          <Typography align="left" variant="h1">
            Verify Your Alen Account
          </Typography>
          <Typography align="left">
            We have sent a confirmation code to {user.alen?.email}.
          </Typography>
          <TextField
            variant="outlined"
            sx={{ marginBottom: "1rem" }}
            type="text"
            placeholder="Confirmation Code"
            label="Confirmation Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          {errors.map((error) => (
            <Typography key={error} color="error">
              {error}
            </Typography>
          ))}
          <Button
            disabled={loading}
            type="submit"
            variant="contained"
            size="large"
          >
            {loading ? "Verifying" : "Verify"}
          </Button>
          <Button onClick={signout}>Relogin to resend code</Button>
        </Box>
      </form>
    </Container>
  );
}
